import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { formatCurrencyDecimals } from 'utils/formats';
import { usePartnerDividends } from '../context/PartnerDividendsContext';

const DividendsTableFooter: FC = () => {
  const { t } = useTranslate();

  const { data } = usePartnerDividends();

  return (
    <tfoot>
      <tr>
        <td className="pl-2 pl-md-3 fw-bold w-20px">{t('Total')}</td>
        <td className="" />
        <td className=" d-none d-md-table-cell" />
        <td className=" d-none d-md-table-cell" />
        <td className=" d-none d-md-table-cell" />
        <td className=" d-none d-md-table-cell" />
        <td className="fw-bold text-right pr-2 pr-md-3">
          {formatCurrencyDecimals(data.totalDividendsAmount)}
        </td>
      </tr>
    </tfoot>
  );
};

export default DividendsTableFooter;
